/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TipoTransporteCriteriaDto } from '../models/tipo-transporte-criteria-dto';
import { TipoTransporteDto } from '../models/tipo-transporte-dto';
import { TipoTransporteFormDto } from '../models/tipo-transporte-form-dto';
import { TipoTransportePageDto } from '../models/tipo-transporte-page-dto';

@Injectable({
  providedIn: 'root',
})
export class TiposTransporteService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTiposTransporte
   */
  static readonly GetTiposTransportePath = '/tipos-transporte';

  /**
   * Pesquisar tipos de transporte.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTiposTransporte()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposTransporte$Response(params?: {
    criteria?: TipoTransporteCriteriaDto;
  }): Observable<StrictHttpResponse<TipoTransportePageDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposTransporteService.GetTiposTransportePath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoTransportePageDto>;
      })
    );
  }

  /**
   * Pesquisar tipos de transporte.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTiposTransporte$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposTransporte(params?: {
    criteria?: TipoTransporteCriteriaDto;
  }): Observable<TipoTransportePageDto> {

    return this.getTiposTransporte$Response(params).pipe(
      map((r: StrictHttpResponse<TipoTransportePageDto>) => r.body as TipoTransportePageDto)
    );
  }

  /**
   * Path part for operation createTipoTransporte
   */
  static readonly CreateTipoTransportePath = '/tipos-transporte';

  /**
   * Criar tipo de transporte.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTipoTransporte()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTipoTransporte$Response(params?: {

    /**
     * apiRequest
     */
    body?: TipoTransporteFormDto
  }): Observable<StrictHttpResponse<TipoTransporteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposTransporteService.CreateTipoTransportePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoTransporteDto>;
      })
    );
  }

  /**
   * Criar tipo de transporte.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTipoTransporte$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTipoTransporte(params?: {

    /**
     * apiRequest
     */
    body?: TipoTransporteFormDto
  }): Observable<TipoTransporteDto> {

    return this.createTipoTransporte$Response(params).pipe(
      map((r: StrictHttpResponse<TipoTransporteDto>) => r.body as TipoTransporteDto)
    );
  }

  /**
   * Path part for operation getTipoTransporte
   */
  static readonly GetTipoTransportePath = '/tipos-transporte/{id}';

  /**
   * Obter tipo de transporte.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTipoTransporte()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoTransporte$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoTransporteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposTransporteService.GetTipoTransportePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoTransporteDto>;
      })
    );
  }

  /**
   * Obter tipo de transporte.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTipoTransporte$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoTransporte(params: {
    id: number;
  }): Observable<TipoTransporteDto> {

    return this.getTipoTransporte$Response(params).pipe(
      map((r: StrictHttpResponse<TipoTransporteDto>) => r.body as TipoTransporteDto)
    );
  }

  /**
   * Path part for operation updateTipoTransporte
   */
  static readonly UpdateTipoTransportePath = '/tipos-transporte/{id}';

  /**
   * Atualizar tipo de transporte.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTipoTransporte()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoTransporte$Response(params: {
    id: number;
    body?: TipoTransporteFormDto
  }): Observable<StrictHttpResponse<TipoTransporteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposTransporteService.UpdateTipoTransportePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoTransporteDto>;
      })
    );
  }

  /**
   * Atualizar tipo de transporte.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTipoTransporte$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoTransporte(params: {
    id: number;
    body?: TipoTransporteFormDto
  }): Observable<TipoTransporteDto> {

    return this.updateTipoTransporte$Response(params).pipe(
      map((r: StrictHttpResponse<TipoTransporteDto>) => r.body as TipoTransporteDto)
    );
  }

  /**
   * Path part for operation ativarTipoTransporte
   */
  static readonly AtivarTipoTransportePath = '/tipos-transporte/{id}/ativar';

  /**
   * Ativar Tipo Transporte.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarTipoTransporte()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTipoTransporte$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoTransporteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposTransporteService.AtivarTipoTransportePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoTransporteDto>;
      })
    );
  }

  /**
   * Ativar Tipo Transporte.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarTipoTransporte$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTipoTransporte(params: {
    id: number;
  }): Observable<TipoTransporteDto> {

    return this.ativarTipoTransporte$Response(params).pipe(
      map((r: StrictHttpResponse<TipoTransporteDto>) => r.body as TipoTransporteDto)
    );
  }

  /**
   * Path part for operation desativarTipoTransporte
   */
  static readonly DesativarTipoTransportePath = '/tipos-transporte/{id}/desativar';

  /**
   * Desativar TipoTransporte.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarTipoTransporte()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTipoTransporte$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoTransporteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposTransporteService.DesativarTipoTransportePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoTransporteDto>;
      })
    );
  }

  /**
   * Desativar TipoTransporte.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarTipoTransporte$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTipoTransporte(params: {
    id: number;
  }): Observable<TipoTransporteDto> {

    return this.desativarTipoTransporte$Response(params).pipe(
      map((r: StrictHttpResponse<TipoTransporteDto>) => r.body as TipoTransporteDto)
    );
  }

}
